import { Leaf } from "lucide-react";
import NewsletterForm from "./NewsletterForm";

export default function Footer() {
  return (
    <footer className="mt-32 border-t border-tc bg-tc-surface/60" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid md:grid-cols-12 gap-10 mb-12">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2 mb-4">
              <Leaf className="w-5 h-5 text-tc-primary" />
              <span className="font-serif text-2xl text-tc-primary">Terra Comune</span>
            </div>
            <p className="text-sm text-tc-muted leading-relaxed italic font-serif">
              Non siamo individui separati. Siamo la stessa radice che cerca la luce.
            </p>
          </div>

          <div className="md:col-span-8">
            <NewsletterForm />
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-10 pt-8 border-t border-tc/40">
          <div className="text-sm text-tc-muted space-y-2">
            <div className="uppercase text-xs tracking-widest text-tc-primary mb-3">Esplora</div>
            <div>Chi siamo</div>
            <div>Realtà sul territorio</div>
            <div>Eventi e laboratori</div>
            <div>Forum della comunità</div>
            <div>Consigli e tecniche</div>
            <div>Contattaci</div>
          </div>
          <div className="text-sm text-tc-muted space-y-2">
            <div className="uppercase text-xs tracking-widest text-tc-primary mb-3">Ispirazione</div>
            <div>Italia che Cambia</div>
            <div>RIVE – Rete Villaggi Ecologici</div>
            <div>Insieme – Comunità di Vicinato</div>
            <div>Cooperà / RetEtica</div>
          </div>
        </div>
      </div>
      <div className="border-t border-tc/50 py-6 text-center text-xs text-tc-muted">
        Seminato con cura — {new Date().getFullYear()}
      </div>
    </footer>
  );
}
